<template>
    <div :class="audit_mode !== true && previous !== true ? 'mb-5 pb-5':'gray-600 font-scale-sm'">
        <div :class="previous === true ? 'p-3 gray-500 rounded border border-color-gray-300 bgray-100':''">
            <b-overlay :show="is_visible_by_pipeline === false"
                       rounded="sm"
                       opacity="0.8"
                       bg-color="#efefef"
            >
                <div v-if="headers">
                    <!-- <div :class="[ sub_name != '' ? 'fw-500 f-110 border-bottom border-color-gray-300 mb-2':'', '' ]"> <span v-if="sub_data_header.required && sub_data_header.required==true">*</span>{{ sub_name }} </div> -->
                    <div class="mb-1 pb-1 d-flex align-items-center">
                        <b-badge class="f-80" variant="basic">
                            <template v-if="is_edit_page && label">
                                {{ sub_code_label }}. ( {{ sub_code }} )
                            </template>
                            <template v-else>
                                {{ sub_code_label }}.
                            </template>
                        </b-badge>

                        <template v-if="required_attachment">
                            <b-badge variant="danger" class="f-85 fw-500 ml-1"> {{ $t('첨부필수') }}</b-badge>
                        </template>

                        <template v-if="required_answer">
                            <b-badge variant="warning" class="f-85 fw-500 ml-1"> {{ $t('필수답변') }}</b-badge>
                        </template>

                        <b-button v-if="!isFieldEmpty(sub_info) && previous !== true"
                                  :id="`i-${ sub_code }`"
                                  class="px-1 py-0 f-80 ml-1"
                                  variant="teal"
                                  size="sm"
                                  v-b-toggle="`sub_info-${sub_code}`"
                        >
                            <fa icon="book-open"></fa>
                            {{ $t('작성 도움말') }}
                        </b-button>

                        <b-button v-if="show_previous === true && previous !== true"
                                  :id="`p-${ sub_code }`"
                                  class="ml-1 px-1 py-0 f-80"
                                  v-b-toggle="`previous-${sub_code}`"
                                  variant="red5"
                                  size="sm"
                        >
                            <fa icon="history"></fa>
                            {{ $t('과거답변 보기') }}
                        </b-button>
                    </div>

                    <!-- qe previous component -->
                    <template v-if="print_mode !== true && previous !== true">
                        <b-collapse :id="`previous-${sub_code}`" class="mb-45">
                            <df-previous-sub
                                :id="`df_table_previous_sub_${sub_code}`"
                                :sub_code="sub_code"
                                :company_id="company_id"
                                :company_name="company_name"
                                :campaign_id="campaign_id"
                                :sub_id="sub_id"
                                :sub_init_id="sub_init_id"
                                @previous-sub-loaded="updatePrevious"
                            >
                            </df-previous-sub>
                        </b-collapse>
                    </template>

                    <div :class="sub_description !== '' ? 'mb-3 pt-1' : 'mb-1'">
                        <div v-if="is_indicate_description" class="mr-1 d-inline f-105">
                            <span> {{ showTranslation(sub_description, sub_description_e, sub_description_c) }}</span>
                        </div>
                        <span v-for="item in tags" :key="item.id">
                            <span v-if="item != ''" class="ml-2 f-80 gray-500"> {{ item }} </span>
                        </span>
                        <span v-if="sub_priority != ''">
                            <b-button variant="icon" class="mx-2">{{ sub_priority }}</b-button>
                        </span>
                    </div>

                    <!-- showTranslation -->
                    <template v-if="!isFieldEmpty(sub_info)">
                        <b-collapse
                            :id="`sub_info-${sub_code}`"
                            :visible="print_mode !== true && audit_mode !== true && previous !== true"
                            class="rounded mb-3 border-0 teal8 bg-teal2 f-95"
                        >
                            <div v-html="showTranslation(sub_info, sub_info_e, sub_info_c)" class="p-3"></div>
                        </b-collapse>
                    </template>
                </div>

                <!-- Table 유형 Sub Component -->
                <b-table-simple :id="form_id" bordered hover style="word-break:keep-all; width:100%;">
                        <b-thead>
                            <b-tr>
                                <!-- <b-td v-for="table_field in $i18n.locale=='ko' ? sub_data_contents['table_header'] : sub_data_contents['table_header_ea']" :key="table_field.index" class="bgray-200"> {{ table_field }} </b-td> -->
                                <template v-if="$i18n.locale === 'ko'">
                                    <b-th v-for="table_field in sub_data_contents['table_header']"
                                          :key="table_field.index"
                                          class="bgray-200 py-2"
                                    >
                                        {{ table_field }}
                                    </b-th>
                                </template>
                                <template v-else>
                                    <b-th v-for="table_field in sub_data_contents[`table_header${lang_append}`]"
                                          :key="table_field.index"
                                          class="bgray-200 py-2"
                                    >
                                        {{ table_field.label }}
                                    </b-th>
                                </template>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="(table_item, index) in sub_data_contents.structure"
                                  :key="table_item.id"
                            >
                                <b-td v-for="(table_field, no) in sub_data_contents['table_header']"
                                      :key="table_field.id"
                                      class="align-middle py-1"
                                      :class="{ 'df-table-required-cell': !isFieldEmpty(table_item.required_cells) && table_item['required_cells'].includes(`${table_field}`) }"
                                      :style="[{ 'max-width:100px': isIE }]"
                                >
                                    <template
                                        v-if="!isFieldEmpty(table_item.noteditables) && table_item['noteditables'].includes(`${table_field}`)">
                                        <span v-html="table_item[`${table_field}${lang_append}`]"></span>
                                    </template>

                                    <template
                                        v-else-if="!isFieldEmpty(table_item.dropdown) && !isFieldEmpty(table_item['dropdown'][`${table_field}${lang_append}`])">

                                        <b-dropdown
                                            :id="`table-${sub_code}-dropdown-${index}-${no}`"
                                            :text="get_dropdown_text(table_item, table_field, index)"
                                            :disabled="is_locked || is_disabled_by_condition || is_disabled_by_parent || is_disabled_by_na"
                                            size="sm"

                                            variant="dark-border"
                                        >
                                            <b-dropdown-item-button
                                                v-for="(dropdown_item, dropdown_item_index) in table_item['dropdown'][`${table_field}${lang_append}`]"
                                                :key="`table-${sub_code}-dropdown-${index}-option-${dropdown_item_index}`"
                                                @click="setDropdown(table_item, table_field, dropdown_item, dropdown_item_index)"
                                                @active="dropdown_item === get_dropdown_text(table_item, table_field, index)"
                                                @input="not_applicable = false"
                                                class="f-90"
                                            >
                                                {{ dropdown_item }}
                                            </b-dropdown-item-button>
                                        </b-dropdown>
                                    </template>

                                    <template
                                        v-else-if="!isFieldEmpty(table_item.calculation) && !isFieldEmpty(table_item['calculation'][`${table_field}${lang_append}`])">
                                        {{ cellCalculate(table_item.calculation[table_field]) }}
                                    </template>

                                    <template v-else>
                                        <b-input-group>
                                            <b-form-input v-model.trim="table_item[`${table_field}`]"
                                                          class="pr-0 f-90"
                                                          :placeholder="showPlaceholder(table_item, `${table_field}${lang_append}`)"
                                                          @input="not_applicable = false"
                                                          @update="textInputSave"
                                                          @blur="textInputSave(true, true)"
                                                          :disabled="is_locked || is_disabled_by_condition || is_disabled_by_parent || is_disabled_by_na"
                                                          v-number-format="table_item['input_type'] && table_item['input_type'][table_field] ? table_item.input_type[table_field] : 'text'"
                                            />
                                            <b-input-group-append>
                                                <b-button
                                                    class="f-80"
                                                    variant="icon-append"
                                                    v-b-modal="`table-text-${sub_code}-${index}-${no}`"
                                                    :disabled="is_locked || is_disabled_by_condition || is_disabled_by_parent || is_disabled_by_na"
                                                >
                                                    <fa icon="pen"></fa>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                        <b-modal
                                            :id="`table-text-${sub_code}-${index}-${no}`"
                                            :title="`${table_field}${lang_append}` ? `${table_field}${lang_append}` : $t('텍스트 상세입력')"
                                            @ok="dbSave"
                                        >
                                            <b-textarea v-model="table_item[`${table_field}`]"
                                                        v-number-format="table_item['input_type'] && table_item['input_type'][table_field] ? table_item.input_type[table_field] : 'text'"
                                                        :disabled="is_locked || is_disabled_by_condition || is_disabled_by_parent || is_disabled_by_na"
                                                        @input="not_applicable = false"
                                                        rows="4"
                                            >
                                            </b-textarea>
                                        </b-modal>
                                    </template>
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>

                <!-- file 저장 -->
                <template v-if="sub_data_header.has_attachment">
                    <df-attached-file-url
                        class="mt-3"
                        :key="sub_code + Math.floor(Math.random() * 1000000)"
                        :sub_id="sub_id"
                        :sub_code="sub_code"
                        :sub_init_id="sub_init_id"
                        :company_id="company_id"
                        :company_name="company_name"
                        :campaign_id="campaign_id"
                        :disabled="is_disabled_attached"
                        :audit_mode="audit_mode"
                        :has_attachment="sub_data_header.has_attachment"
                        :label="label"
                        :previous="previous"
                    >
                    </df-attached-file-url>
                </template>

                <!-- 저장 validation -->
                <div v-if="previous !== true && audit_mode !== true"
                     :class="validation_style" @click="retrySave"
                     class="pt-2 float-right"
                >
                    <fa v-if="validation_icon !== ''" :icon="validation_icon"></fa>
                    {{ validation_comment }}
                </div>

                <!-- Child Component -->
                <sub-component v-for="(item, index) in child_subs" :key="item.id"
                               :is_final_sub_component="index === child_subs.length - 1 ? true : false"
                               :disabled="is_locked || is_disabled_by_condition || is_disabled_by_parent"
                               :sub_type="item.sub_type"
                               :item="item"
                               :audit_mode="audit_mode"
                               :is_disabled_by_parent="is_disabled_by_parent">
                </sub-component>

                <!-- is_visible_by_pipeline 조건에 따른 해당없음 overlay -->
                <template v-slot:overlay>
                    <DFPipelineOverlay :prev_sub_info="prev_sub_info"
                                       :pipeline_title="pipeline_title"
                    />
                </template>
            </b-overlay>
        </div>
    </div>
</template>
<script>
import {SubComponentMixin} from '@core_mixins/SubComponentMixin'
import DFPreviousSub from '@core_components/client/components/subs/previous_sub/DFPreviousSub'
import DFPipelineOverlay from "@core_components/client/components/subs/elements/DFPipelineOverlay";

export default {
    name: 'df-table',
    mixins: [SubComponentMixin],
    components: {
        'df-previous-sub': DFPreviousSub,
        DFPipelineOverlay,
    },
    data() {
        return {
            show_previous: false,
            check_data_updated: false, // attach 용 사용자 입력 
            mapDropDownData: {},
        }
    },
    created() {
        // dropdown 데이터 가공
        const mapDropDownData = {}

        this.sub_data_contents.structure.forEach((elem, i) => {
            if(elem.dropdown == null) {
                return
            }
            this.sub_data_contents.table_header.forEach((header) => {
                if (elem.dropdown && elem.dropdown[header]) {
                    if (mapDropDownData[i] == null) {
                        mapDropDownData[i] = {};
                    }
                    elem.dropdown[header].forEach((item, idx) => {
                        mapDropDownData[i][item] = {
                            'ko': item,
                            'en': elem.dropdown[`${header}_ea`] ? elem.dropdown[`${header}_ea`][idx] : item,
                            'ca': elem.dropdown[`${header}_ca`] ? elem.dropdown[`${header}_ca`][idx] : item,
                        };
                    });
                }
            });
        });
        
        this.mapDropDownData = JSON.parse(JSON.stringify(mapDropDownData))
    },
    computed: {
        get_dropdown_text(){
            return (table_item, table_field, index) => {
                return this.mapDropDownData?.[index]?.[table_item[table_field]]?.[this.$i18n.locale] 
            }
        }
    },
    methods: {
        textInputSave(update_pipeline) {
            if (typeof update_pipeline == "undefined") {
                update_pipeline = false
            }
            this.check_data_updated = true

            this.save_state = 'saving'
            this.debouncedSave(update_pipeline, true)
        },
        showPlaceholder(table_item, table_field) {
            if (!this.isFieldEmpty(table_item.placeholder) && !this.isFieldEmpty(table_item['placeholder'][table_field])) {
                return table_item['placeholder'][table_field]
            } else {
                return ''
            }
        },
        async setDropdown(table_item, table_field, contents, contents_index) {
            table_item[table_field] = table_item['dropdown'][table_field][contents_index]
            
            // if (this.$i18n.locale === 'ko') {
            //     table_item[table_field] = contents
            //
            //     if (!this.isFieldEmpty(table_item[`${table_field}_ea`]) && !this.isFieldEmpty(table_item['dropdown'][`${table_field}_ea`])) {
            //         table_item[`${table_field}_ea`] = table_item['dropdown'][`${table_field}_ea`][contents_index]
            //     }
            //
            //     if (!this.isFieldEmpty(table_item[`${table_field}_ca`]) && !this.isFieldEmpty(table_item['dropdown'][`${table_field}_ca`])) {
            //         table_item[`${table_field}_ca`] = table_item['dropdown'][`${table_field}_ca`][contents_index]
            //     }
            //
            // } else {
            //     table_item[`${table_field}${this.lang_append}`] = contents
            //
            //     if (this.$i18n.locale !== 'en') {
            //         if (!this.isFieldEmpty(table_item[`${table_field}_ea`]) && !this.isFieldEmpty(table_item['dropdown'][`${table_field}_ea`])) {
            //             table_item[`${table_field}_ea`] = table_item['dropdown'][`${table_field}_ea`][contents_index]
            //         }
            //
            //     } else {
            //         if (!this.isFieldEmpty(table_item[`${table_field}_ca`]) && !this.isFieldEmpty(table_item['dropdown'][`${table_field}_ca`])) {
            //             table_item[`${table_field}_ca`] = table_item['dropdown'][`${table_field}_ca`][contents_index]
            //         }
            //     }
            //     table_item[table_field] = table_item['dropdown'][table_field][contents_index]
            //
            // }

            return await this.radioSave()
        },
        cellCalculate(str) {
            let var_item = []
            let calculation_item = []

            var_item = str.match(/([A-Z0-9\(\)]+)/gi)
            calculation_item = str.match(/([+-/*])/g)

            let result = ''

            //오류처리들
            if (!var_item[0]) {
                //console.log('셀 아이템이 없습니다')
                return false
            }
            if (var_item.length != calculation_item.length + 1) {
                //console.log('셀 아이템과 연산자 개수가 맞지 않습니다.')
                return false
            }

            //만약 셀 참조일 경우, cellValue로 변환
            if (var_item[0].match(/[A-Z]/i)) result = this.cellValue(var_item[0])
            else result = String(var_item[0])

            for (let i = 0; i < calculation_item.length; i++) {
                if (var_item[i + 1].match(/[A-Z]/i)) {
                    var_item[i + 1] = this.cellValue(var_item[i + 1])
                } else var_item[i + 1] = String(var_item[i + 1])
                result = result + calculation_item[i] + var_item[i + 1]
            }

            //console.log(result)
            result = eval(result)
            return result.toLocaleString(undefined, {maximumFractionDigits: 0})

        },
        cellValue(var_item) {
            //열번호, 행번호 순으로 읽어옴
            let col_index_array = var_item.match(/([A-Z])/gi)
            let row_index_array = var_item.match(/(\d+)/g)

            let row_parser = {
                'A': 0,
                'B': 1,
                'C': 2,
                'D': 3,
                'E': 4,
                'F': 5,
                'G': 6,
                'H': 7,
                'I': 8,
                'J': 9,
                'K': 10,
                'L': 11,
                'M': 12,
                'N': 13,
                'O': 14,
                'P': 15,
                'Q': 16,
                'R': 17,
                'S': 18,
                'T': 19,
                'U': 20,
                'V': 21,
                'W': 22,
                'X': 23,
                'Y': 24,
                'Z': 25
            }

            let col_index = ''
            let row_index = ''

            // col_index 처리함. col_index는 A = 0 , B = 1, C = 2, D = 3, E = 4의 순서로 
            // 숫자로 바꾼 뒤 sub_data_header의 table_header에서 해당 아이템을 읽어 옴 

            // 먼저 테이블의 전체 크기를 구해 둠
            let max_col_index = this.sub_data_contents.table_header.length
            let max_row_index = this.sub_data_contents.structure.length

            if (!col_index_array[0] && !row_parser[col_index_array[0]]) {
                //console.log('열 번호가 없습니다. 읽어온 값:'+col_index_array)
                return 0
            } else {
                //열 번호 검증
                if (row_parser[col_index_array[0]] > max_col_index) {
                    //console.log('수식오류(열 크기 벗어남 max_col_index:'+max_col_index+'col_index'+row_parser[col_index_array[0]])
                    return 0
                }
                col_index = this.sub_data_contents.table_header[row_parser[col_index_array[0]]]
            }

            // row index의 경우에는 1부터 시작했는데 실제로 0부터 내부적으로 시작했기 떄문에 1을 뺴줌 
            if (!row_index_array[0]) {
                //console.log('행 번호가 없습니다. 읽어온 값:'+row_index_array)
                return 0
            } else row_index = row_index_array[0] - 1

            //행 번호 검증
            if (row_index > max_row_index) {
                //console.log('수식오류(행 크기 벗어남 max_row_index:'+max_row_index+'row_index'+row_index)
                return 0
            }

            let cell_value = this.sub_data_contents.structure[row_index][col_index]
            //console.log('cell_value'+row_index+'행'+col_index+'열:'+cell_value)

            if (!cell_value) {
                //console.log('셀 값이 정의되지 않았습니다. 0으로 간주합니다.')
                cell_value = '0'
            }

            if (typeof (cell_value) != 'string') cell_value = String(cell_value)

            //원래 스트링이 (로 시작하거나, )로 끝났다면, 덧붙여줌
            if (var_item.match(/^\(+/i)) cell_value = var_item.match(/^\(+/i) + cell_value
            if (var_item.match(/\)+$/i)) cell_value = cell_value + var_item.match(/\)+$/i)

            //먼저 점 앞에 오는 숫자만 남기고(정수화) => 특수문자를 제거하고 => 괄호와 숫자부분만 남겨서 스트링인채로 리턴
            //console.log(var_item)
            //console.log(cell_value.replace(/\.\S*/gi,'').replace(/[\{\}\[\]\/?.,;:|*~`!^\-_+<>@\#$%&\\\=\'\"]/gi,'').match(/^[\(0-9\)]+/))
            return cell_value.replace(/\.\S*/gi, '').replace(/[\{\}\[\]\/?.,;:|*~`!^\-_+<>@\#$%&\\\=\'\"]/gi, '').match(/^[\(0-9\)]+/)
        },
        updatePrevious(flag) {
            this.show_previous = flag
        }
    }
}
</script>

<style>
@media (max-width: 540px) {
    .d-block-helper {
        display: block;
    }
}

.ie-table-input {
    width: 50%;
}

/* 관리자가 표 편집기에서 지정한 필수 셀(structure[row].required_cells) 표시 */
.df-table-required-cell {
    box-shadow: inset 3px 0 0 #dc3545;
}


</style>
